
import Platform from "../../../libs/utility/Platform";
import { Theme } from "../constants";
export default {
    overlay: {
        visibility: "hidden",
        opacity: 0,
        position: "fixed",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        background: "rgba(0, 0, 0, 0.7)",
        transition: "opacity 500ms",
        zIndex: 10,
    },
    drawerContainer: {
        display: "none",
        position: "fixed",
        top: "72.59px", 
        right:"0px", 
        height: "100%", 
        width: Platform.isMobileView() ? "100%" : "626px", 
        background: Theme.BACKGROUND_PRIMARY, 
        overflowX: "hidden", 
        overflowY: "scroll", 
        padding: Platform.isMobileView() ? "5px" : "25px", 
        bkitOverflowScrolling: "touch",
        transition: "transform 0.3s ease",
        zIndex: 11,
    },
    showDrawer: {
        display: "block", 
    },
    closeIcon:{
        position: "absolute",
        right: "20px",
    },
    header: {
        display: "flex",
        flexDirection: "row",
    },
    drawerBody: {
        padding: "5px 15px",
        height: "100%",
    },
    txDrawerBody: {
        display: "flex",
        flexDirection: "column",
        marginTop: "30px",
        maxHeight: "75%",
        minHeight: "75%",
        overflow: "auto",
    },
    title: {
        fontWeight: 700,
        fontSize: "20px",
        lineHeight: "19px",
        color: Theme.TEXT_PRIMARY_BLACK,
    },
    txDrawerfooter: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        gap: "16px",
        marginTop: "20px",
    },
    footerButtons: {
        width: "120px",
    },
    maxHeight90: {
        maxHeight: '85%'
    }
}